<template>
  <picture
    :class="[imageData.cssClass, { 'responsive-image--new-game': imageData.isNewGame }]"
    class="responsive-image">
    <template v-if="lazyload">
      <template v-if="imageData.sources && imageData.sources.length">
        <source
          v-for="source in imageData.sources"
          :key="`${source.media}-${source.type}`"
          :media="source.media"
          :type="source.type || ''"
          :data-srcset="source.srcset" />
      </template>
      <img
        :data-src="imageData.default"
        :alt="imageData.alt"
        :title="imageData.title"
        :class="{'responsive-image__img--fill': fill }"
        class="responsive-image__img lazyload"
        :data-fallback-img="imageData.fallback"
        @error="_skGlobal.handleFallbackImg" />
    </template>
    <template v-else>
      <template v-if="imageData.sources && imageData.sources.length">
        <source
          v-for="source in imageData.sources"
          :key="`${source.media}-${source.type}`"
          :media="source.media"
          :type="source.type || ''"
          :srcset="source.srcset" />
      </template>
      <img
        :src="imageData.default"
        :alt="imageData.alt"
        :title="imageData.title"
        :class="{'responsive-image__img--fill': fill }"
        class="responsive-image__img"
        :data-fallback-img="imageData.fallback"
        @error="_skGlobal.handleFallbackImg" />
    </template>
  </picture>
</template>

<script>
export default {
  name: 'ResponsiveImage',

  props: {
    imageData: {
      type: Object,
      required: true,
    },

    lazyload: {
      type: Boolean,
      default: false,
    },

    fill: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .responsive-image {
    --border-radius: 0px;

    width: 100%;
  }

  .responsive-image__img {
    width: 100%;
    overflow: hidden;
    border-radius: var(--border-radius);
  }

  .responsive-image--new-game {
    background-color: $color--additional-dark-blue;

    .responsive-image__img {
      mix-blend-mode: luminosity;
    }
  }

  .responsive-image__img--fill {
    @include fill;
  }
</style>
